angular.module('omfm').service('SaoContact', SaoContactService);

SaoContactService.$inject = ['$resource', 'ServerInterceptor'];

function SaoContactService($resource, ServerInterceptor) {
	return $resource('/sao', {"id": "@id"}, {
		'list':{
			'url':'/sao/contact',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'letters':{
			'url':'/sao/contact/letters',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'export':{
			'url':'/sao/contact/:id/export',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'save':{
			'url':'/sao/contact/:id',
			'method': 'post',
			'interceptor': ServerInterceptor
		}
	})
}